import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type UndoImportActionProps = {
    /** The import posted a book entry, which the undo reverses. */
    posted: boolean;
    /** Opens the confirm. */
    onUndo: () => void;
};

/**
 * **Undo this import** (danger-soft) over its helper: undo lasts until
 * onboarding is finished, and says what it takes away. The helper describes
 * the button (`aria-describedby`). Full width on a phone.
 */
export const UndoImportAction: React.FC<UndoImportActionProps> = ({
    posted,
    onUndo,
}) => {
    const { t } = useTranslation('pages');
    const helperId = React.useId();

    return (
        <div className="flex flex-col gap-2 sm:max-w-sm">
            <Button
                aria-describedby={helperId}
                className="w-full sm:w-auto sm:self-start"
                onPress={onUndo}
                variant="danger-soft"
                {...getNodeTestIdProp('catalog-import-result-undo')}
            >
                {t('catalogImport.result.undo.action')}
            </Button>
            <Typography
                color="muted"
                id={helperId}
                type="body-sm"
                {...getNodeTestIdProp('catalog-import-result-undo-helper')}
            >
                {posted
                    ? t('catalogImport.result.undo.helper')
                    : t('catalogImport.result.undo.helperNothingPosted')}
            </Typography>
        </div>
    );
};
